import { useQuery } from "react-query";
import { PaginatedFilter } from "../types/axios.types";
import { fetchDocumentationsPaginated } from "../queries/documentation.queries";

export const useDocumentationsPaginated = (page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
    const query = useQuery(['documentations-paginated', page, size, search, filters, sortBy], () => {
        try {
            return fetchDocumentationsPaginated(page, size, search, filters, sortBy);
        } catch (err) {
            return null;
        }
    }, { keepPreviousData: true })
    return query?.data;
}